import { render } from "./BaseTable.vue?vue&type=template&id=6a47afa3&scoped=true&ts=true"
import script from "./BaseTable.vue?vue&type=script&lang=ts"
export * from "./BaseTable.vue?vue&type=script&lang=ts"

import "./BaseTable.vue?vue&type=style&index=0&id=6a47afa3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a47afa3"]])

export default __exports__